export const applyThemeForAntd = (theme) => {
    if (!theme) {
        throw new Error(`Theme is ${theme}`);
    }
    const antdThemeConfig = {
        token: {
            fontFamily: theme.Typography.FontFamily,
            colorTextBase: theme.Color.Neutrals.Text,
            colorTextPlaceholder: theme.Color.Neutrals.Gray,
            colorBgContainer: theme.Color.Neutrals.Paper,
            colorBgContainerDisabled: theme.Color.Neutrals.Light,
            colorBgElevated: theme.Components.Panel.Background,
            colorBgTextHover: theme.Color.Brand.Primary,
            colorBorder: theme.Color.Brand.Border,
            colorPrimary: theme.Color.Brand.Primary,
            colorPrimaryBorder: theme.Color.Brand.Primary,
            colorPrimaryHover: theme.Color.Brand.Primary,
            colorText: theme.Color.Neutrals.Text,
            colorTextDisabled: theme.Color.Neutrals.Gray,
            colorWhite: theme.Color.NeutralsFixed.Paper,
            borderRadius: theme.Border.Radius.Small,
            borderRadiusLG: theme.Border.Radius.Large,
        },
        components: {
            Select: {
                fontFamily: theme.Typography.FontFamily,
                colorBorder: theme.Color.Neutrals.Border,
                colorText: theme.Color.Neutrals.Text,
            },
            Form: {
                verticalLabelPadding: 0,
                itemMarginBottom: theme.Spacing.Size.Small,
            },
            Input: {
                fontFamily: theme.Typography.FontFamily,
                hoverBorderColor: theme.Color.Brand.Primary,
                hoverBg: theme.Color.Neutrals.Paper,
                activeBorderColor: theme.Color.Brand.Primary,
                activeBg: theme.Color.Neutrals.Paper,
                colorBorder: theme.Color.Neutrals.Border,
                colorText: theme.Color.Neutrals.Text,
                addonBg: theme.Color.Neutrals.Light,
                borderRadiusLG: theme.Border.Radius.Medium,
            },
            Menu: {
                fontFamily: theme.Typography.FontFamily,
                itemSelectedColor: theme.Color.Brand.Primary,
                itemSelectedBg: theme.Color.Brand.Lightest,
                itemColor: theme.Color.Neutrals.Text,
                iconMarginInlineEnd: theme.Spacing.Size.XSmall,
                colorBgTextHover: theme.Color.Brand.Lightest,
            },
            Tabs: {
                inkBarColor: theme.Color.Brand.Primary,
                itemActiveColor: theme.Color.Brand.Primary,
                itemColor: theme.Color.Neutrals.Text,
                itemHoverColor: theme.Color.Brand.Primary,
                itemSelectedColor: theme.Color.Brand.Primary,
                fontFamily: theme.Typography.FontFamily,
                colorBorderSecondary: theme.Color.Neutrals.Border,
            },
            Modal: {
                colorBgTextHover: 'unset',
                wireframe: true,
            },
            Tag: {
                defaultColor: theme.Color.Brand.Primary,
                defaultBg: theme.Color.Brand.Lightest,
                colorBorder: theme.Color.Brand.Primary,
                borderRadiusSM: theme.Border.Radius.XSmall,
            },
            Tour: {
                closeBtnSize: theme.Spacing.Size.Medium,
                primaryNextBtnHoverBg: theme.Color.Brand.Light,
                primaryPrevBtnBg: theme.Color.Brand.Dark,
            },
        },
    };
    return antdThemeConfig;
};
//# sourceMappingURL=AntdThemeConfig.js.map